export default function EditIcon({
  height,
  width,
  size,
}: {
  height?: number;
  width?: number;
  size?:number;
}) {
  return (
    <svg
      width={width || size || "16"}
      height={height || size || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4432 3.56066C11.6956 2.81311 10.4836 2.81311 9.73605 3.56067L9.18529 4.11145C9.17189 4.12232 9.15893 4.134 9.14645 4.14647C9.13398 4.15894 9.12231 4.17191 9.11143 4.18531L3.65036 9.64647C3.58074 9.71609 3.53323 9.80471 3.51377 9.90123L3.00987 12.4012C2.97681 12.5652 3.02796 12.7349 3.14614 12.8533C3.26432 12.9716 3.43387 13.0231 3.59792 12.9903L6.10183 12.4903C6.19868 12.471 6.28763 12.4234 6.35747 12.3536L12.4432 6.26776C13.1907 5.52021 13.1907 4.3082 12.4432 3.56066ZM9.50192 5.20904L10.7948 6.50193L5.75746 11.5394L4.13854 11.8626L4.46423 10.2468L9.50192 5.20904ZM11.5019 5.79482L10.209 4.50192L10.4432 4.26777C10.8002 3.91074 11.379 3.91074 11.7361 4.26777C12.0931 4.62479 12.0931 5.20363 11.7361 5.56066L11.5019 5.79482Z"
        fill={"currentColor"}
      />
    </svg>
  );
}
